import React, { Component } from 'react'
import './styles.scss'
import ToolTip from '../ToolTip'
import TooltipWrapper from '../TooltipWrapper'
import PropTypes from 'prop-types'

class Icon extends Component {
  render () {
    const {
      size,
      type,
      icon: customIcon,
      fillColor,
      background,
      tooltip,
      faClassName,
      imClassName,
      extraClassNames,
      tooltipPosition,
      onClick,
      cursor,
      useNewTooltip,
      tooltipProps,
      ...rest
    } = this.props

    let icon
    if (customIcon) {
      icon = customIcon
    } else if (type === 'fa') {
      icon = <i className={`${type} ${faClassName}`}/>
    } else if (type === 'im') {
      icon = <i className={`${type} ${imClassName}`}/>
    } else {
      icon = <span/>
    }

    const classNames = `Icon Icon-${size} Icon-${type} Icon-BG-${background} ToolTip-Handle clearfix${extraClassNames ? ` ${extraClassNames}` : ''}`

    const iconEl = (
      <span
        {...rest}
        className={classNames}
        style={{ color: fillColor, cursor }}
        onClick={onClick}
      >
        {tooltip && !useNewTooltip && (
          <ToolTip position={tooltipPosition}>
            {tooltip}
          </ToolTip>
        )}
        {icon}
      </span>
    )

    if (tooltip && useNewTooltip) {
      return (
        <TooltipWrapper
          content={tooltip}
          place={tooltipPosition}
          {...tooltipProps}
        >
          {iconEl}
        </TooltipWrapper>
      )
    }

    return iconEl
  }
}

Icon.defaultProps = {
  size: 'small'
}

Icon.propTypes = {
  size: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
  fillColor: PropTypes.string,
  background: PropTypes.string,
  tooltip: PropTypes.any,
  faClassName: PropTypes.string,
  imClassName: PropTypes.string,
  extraClassNames: PropTypes.string,
  // with the old ToolTip, only 'bottom' | 'right' are supported. with
  // `useNewTooltip`, this maps to TooltipWrapper's `place` (top/right/bottom/left + variants).
  tooltipPosition: PropTypes.oneOfType([
    ToolTip.propTypes.position,
    TooltipWrapper.propTypes.place,
  ]),
  cursor: PropTypes.string,
  // opt in to the react-tooltip based TooltipWrapper instead of the legacy CSS ToolTip.
  useNewTooltip: PropTypes.bool,
  // extra props forwarded to TooltipWrapper (delayShow, clickable, maxWidth, positionStrategy, ...).
  tooltipProps: PropTypes.object,
}

export default Icon
